$.widget('ui.slider', $.ui.slider, {
    options: {
        chart: false,
    },
    _refreshValue: function () {
        var lastValPercent,
            valPercent,
            value,
            valueMin,
            valueMax,
            oRange = this.options.range,
            oChart = this.options.chart,
            o = this.options,
            that = this,
            animate = !this._animateOff ? o.animate : false,
            _set = {};

        if (this._hasMultipleValues()) {
            this.handles.each(function (i) {
                if (oChart) {
                    if (i === 0) {
                        valPercent =
                            ((that.values(i) - that._valueMin()) / (that._valueMax() - that._valueMin() + 1)) * 100;
                    }
                    if (i === 1) {
                        valPercent =
                            ((that.values(i) - that._valueMin() + 1) / (that._valueMax() - that._valueMin() + 1)) * 100;
                    }
                } else {
                    valPercent = ((that.values(i) - that._valueMin()) / (that._valueMax() - that._valueMin())) * 100;
                }

                _set[that.orientation === 'horizontal' ? 'left' : 'bottom'] = valPercent + '%';
                $(this).stop(1, 1)[animate ? 'animate' : 'css'](_set, o.animate);/*eslint-disable-line*/
                if (that.options.range === true) {
                    if (that.orientation === 'horizontal') {
                        if (i === 0) {
                            that.range.stop(1, 1)[animate ? 'animate' : 'css'](
                                {
                                    left: valPercent + '%',
                                },
                                o.animate
                            );
                        }
                        if (i === 1) {
                            that.range[animate ? 'animate' : 'css'](
                                {
                                    width: valPercent - lastValPercent + '%',
                                },
                                {
                                    queue: false,
                                    duration: o.animate,
                                }
                            );
                        }
                    } else {
                        if (i === 0) {
                            that.range.stop(1, 1)[animate ? 'animate' : 'css'](
                                {
                                    bottom: valPercent + '%',
                                },
                                o.animate
                            );
                        }
                        if (i === 1) {
                            that.range[animate ? 'animate' : 'css'](
                                {
                                    height: valPercent - lastValPercent + '%',
                                },
                                {
                                    queue: false,
                                    duration: o.animate,
                                }
                            );
                        }
                    }
                }
                lastValPercent = valPercent;
            });
        } else {
            value = this.value();
            valueMin = this._valueMin();
            valueMax = this._valueMax();
            valPercent = valueMax !== valueMin ? ((value - valueMin) / (valueMax - valueMin)) * 100 : 0;
            _set[this.orientation === 'horizontal' ? 'left' : 'bottom'] = valPercent + '%';
            this.handle.stop(1, 1)[animate ? 'animate' : 'css'](_set, o.animate);

            if (oRange === 'min' && this.orientation === 'horizontal') {
                this.range.stop(1, 1)[animate ? 'animate' : 'css'](
                    {
                        width: valPercent + '%',
                    },
                    o.animate
                );
            }
            if (oRange === 'max' && this.orientation === 'horizontal') {
                this.range.stop(1, 1)[animate ? 'animate' : 'css'](
                    {
                        width: 100 - valPercent + '%',
                    },
                    o.animate
                );
            }
            if (oRange === 'min' && this.orientation === 'vertical') {
                this.range.stop(1, 1)[animate ? 'animate' : 'css'](
                    {
                        height: valPercent + '%',
                    },
                    o.animate
                );
            }
            if (oRange === 'max' && this.orientation === 'vertical') {
                this.range.stop(1, 1)[animate ? 'animate' : 'css'](
                    {
                        height: 100 - valPercent + '%',
                    },
                    o.animate
                );
            }
        }
    },
});

(function () {
    var facetDateChart = {
        $element: $('.facetDateChart'),
        rangeStartVal: null,
        rangeEndVal: null,
        yearWeights: null,
        queryID: null,
        height: 200,
        amplifierRatio: null,
        url: location.href,

        init: function () {
            facetDateChart.rangeStartVal = parseInt(facetDateChart.$element.data('min'));
            facetDateChart.rangeEndVal = parseInt(facetDateChart.$element.data('max'));
            facetDateChart.yearWeights = facetDateChart.$element.data('yearweights');
            facetDateChart.queryID = facetDateChart.$element.data('queryid');
            facetDateChart.amplifierRatio = parseInt(facetDateChart.$element.data('amplifierratio'));

            facetDateChart.chart.init();
            facetDateChart.control();
        },
        control: function () {
            $(document).on('slide:opened', function (event) {
                $('.ui-slider-handle__indicator, .ui-slider-handle__label').remove();
                facetDateChart.init();
                $(this).off(event);
            });
        },
        getSelectedRange: function (sliderRange) {
            var queryString = facetDateChart.url.indexOf('?') !== -1 ? facetDateChart.url.split('?')[1] : '';
            var queryStringObj = {};

            if (queryString) {
                queryString.split('&').map(function (value) {
                    var keyVal = value.split('=');
                    queryStringObj[keyVal[0]] = keyVal[1];
                });

                if (queryStringObj.AfterYear && queryStringObj.BeforeYear) {
                    return [queryStringObj.AfterYear, queryStringObj.BeforeYear];
                }
            }

            return [parseInt(facetDateChart.rangeStartVal), parseInt(facetDateChart.rangeEndVal)];
        },
        updateUrl: function (startYear, endYear) {
            facetDateChart.removeParam('AfterYear');
            facetDateChart.removeParam('BeforeYear');
            facetDateChart.removeParam('queryID');
            facetDateChart.url +=
                (facetDateChart.url.indexOf('?') > -1 ? '&' : '?') +
                'AfterYear=' +
                startYear +
                '&BeforeYear=' +
                endYear +
                '&queryID=' +
                facetDateChart.queryID;
            window.location = facetDateChart.url;
        },
        removeParam: function (key) {
            var baseUrl = facetDateChart.url.split('?')[0];
            var queryString = facetDateChart.url.indexOf('?') !== -1 ? facetDateChart.url.split('?')[1] : '';
            var queryStringObj = {};

            if (queryString) {
                queryString.split('&').map(function (value) {
                    var keyVal = value.split('=');
                    queryStringObj[keyVal[0]] = keyVal[1];
                });
                if (queryStringObj[key]) {
                    delete queryStringObj[key];
                }
                queryString = Object.keys(queryStringObj)
                    .map(function (value) {
                        return value + '=' + queryStringObj[value];
                    })
                    .join('&');
                facetDateChart.url = baseUrl + (queryString ? '?' + queryString : '');
            }
        },
        chart: {
            //more info https://www.jqueryscript.net/chart-graph/Histogram-Slider-Plugin-jQuery.html

            init: function () {
                facetDateChart.chart.setOptions();

                const self = facetDateChart.$element,
                    dataItems = self.options.data.items,
                    bins = new Array(self.options.numberOfBins).fill(0),
                    range = self.options.numberOfBins,
                    rangePerBin = range / self.options.numberOfBins;

                for (let i = 0; i < dataItems.length; i++) {
                    let index = parseInt(dataItems[i].value / rangePerBin),
                        increment = 1;

                    if (dataItems[i].count) {
                        // Handle grouped data structure
                        increment = parseInt(dataItems[i].count);
                    }

                    bins[index] += increment;
                }

                const chartName = self.attr('name') + '__chart',
                    sliderName = self.attr('name') + '__slider';

                const wrapHtml =
                    "<div class='" +
                    chartName +
                    "' style='height:" +
                    self.options.height +
                    "px; overflow: hidden;'></div>" +
                    "<div class='" +
                    sliderName +
                    "'></div>";

                self.html(wrapHtml);

                const heightRatio = facetDateChart.chart.calculateHeightRatio(bins, self.options.height),
                    widthPerBin = 100 / self.options.numberOfBins;

                for (let i = 0; i < bins.length; i++) {
                    let binRange = facetDateChart.chart.getBinRange(
                            rangePerBin,
                            i,
                            facetDateChart.$element.options.sliderRange[0]
                        ),
                        inRangeClass = 'bin-color-selected',
                        outRangeClass = 'bin-color';

                    if (self.options.optimalRange[0] <= binRange[0] && binRange[0] <= self.options.optimalRange[1]) {
                        inRangeClass = 'bin-color-optimal-selected';
                        outRangeClass = 'bin-color-optimal';
                    }

                    const toolTipHtml = self.options.showTooltips
                        ? "<span class='tooltiptext'>" + binRange[0] + '/' + bins[i] + '</span>'
                        : '';

                    const scaledValue = parseInt(bins[i] * heightRatio),
                        height = facetDateChart.chart.convertToHeight(scaledValue),
                        inRangeOffset = parseInt(self.options.height - height),
                        outRangeOffset = -parseInt(self.options.height - height * 2);

                    const binHtml =
                        "<div class='tooltip' style='float:left!important;width:" +
                        widthPerBin +
                        "%;'>" +
                        toolTipHtml +
                        "<div class='bin in-range " +
                        inRangeClass +
                        "' style='height:" +
                        height +
                        'px;bottom:-' +
                        inRangeOffset +
                        "px;position: relative;'></div>" +
                        "<div class='bin out-of-range " +
                        outRangeClass +
                        "' style='height:" +
                        height +
                        'px;bottom:' +
                        outRangeOffset +
                        "px;position: relative;'></div>" +
                        '</div>';

                    $('.' + chartName).append(binHtml);
                }

                $('.' + sliderName).slider({
                    range: true,
                    min: self.options.sliderRange[0],
                    max: self.options.sliderRange[1],
                    values: self.options.selectedRange,
                    chart: true,
                    slide: function (event, ui) {
                        facetDateChart.chart.update(
                            ui.values,
                            self.options.sliderRange[0],
                            rangePerBin,
                            chartName,
                            sliderName
                        );
                    },
                    create: function (event, ui) {
                        $(event.target)
                            .find('.ui-slider-handle')
                            .append('<span class="ui-slider-handle__indicator"></span>')
                            .first()
                            .addClass('first');
                        $(event.target)
                            .find('.ui-slider-handle')
                            .append('<span class="ui-slider-handle__label"></span>');
                        $(event.target)
                            .find('.ui-slider-handle__indicator')
                            .height(facetDateChart.height + 10);
                    },
                    stop: function (event, ui) {
                        facetDateChart.updateUrl(ui.values[0], ui.values[1]);
                    },
                });

                facetDateChart.chart.update(
                    self.options.selectedRange,
                    self.options.sliderRange[0],
                    rangePerBin,
                    chartName,
                    sliderName
                );
            },

            setOptions: function () {
                var data = {items: []};
                $.each(facetDateChart.yearWeights, function (index, value) {
                    data.items.push({value: index, count: value * facetDateChart.amplifierRatio});
                });

                facetDateChart.chart.setHeight(data);

                const options = {
                    data: data,
                    sliderRange: [facetDateChart.rangeStartVal, facetDateChart.rangeEndVal],
                    optimalRange: [facetDateChart.rangeStartVal, facetDateChart.rangeEndVal],
                    selectedRange: facetDateChart.getSelectedRange(),
                    numberOfBins: data.items.length,
                    height: facetDateChart.height,
                    showTooltips: false,
                };

                facetDateChart.$element.options = options;
            },
            setHeight: function (data) {
                facetDateChart.height =
                    Math.max.apply(
                        Math,
                        data.items.map(function (o) {
                            return o.count;
                        })
                    ) *
                        5 +
                    20;

                if (facetDateChart.height < 150) {
                    facetDateChart.height = 150;
                }
            },
            update: function (selectedRange, sliderMin, rangePerBin, chartName, sliderName) {
                var leftValue = selectedRange[0],
                    rightValue = selectedRange[1],
                    $minLabelHandler = $('.' + sliderName)
                        .find('.ui-slider-handle.first .ui-slider-handle__label')
                        .html(leftValue),
                    $maxLabelHandler = $('.' + sliderName)
                        .find('.ui-slider-handle:not(.first) .ui-slider-handle__label')
                        .html(rightValue);

                // set opacity per bin based on the slider values
                $('.' + chartName + ' .in-range').each(function (index, bin) {
                    var binRange = facetDateChart.chart.getBinRange(rangePerBin, index, sliderMin);

                    if (binRange[1] < rightValue) {
                        // Set opacity based on left (min) slider
                        if (leftValue > binRange[1]) {
                            facetDateChart.chart.setOpacity(bin, 0);
                        } else if (leftValue < binRange[0]) {
                            facetDateChart.chart.setOpacity(bin, 1);
                        } else {
                            //setOpacity(bin, 1);
                            facetDateChart.chart.setOpacity(bin, 1 - (leftValue - binRange[0]) / rangePerBin);
                        }
                    } else if (binRange[0] > leftValue) {
                        // Set opacity based on right (max) slider value
                        if (rightValue > binRange[1]) {
                            facetDateChart.chart.setOpacity(bin, 1);
                        } else if (rightValue < binRange[0]) {
                            facetDateChart.chart.setOpacity(bin, 0);
                        } else {
                            facetDateChart.chart.setOpacity(bin, 1 - (rightValue - binRange[0]) / rangePerBin);
                        }
                    }
                });

                facetDateChart.chart.setLabelHandlersPosition($minLabelHandler, $maxLabelHandler);

                setTimeout(function () {
                    facetDateChart.chart.setLabelHandlersPosition($minLabelHandler, $maxLabelHandler);
                }, 500);
            },
            setLabelHandlersPosition: function ($minLabelHandler, $maxLabelHandler) {
                var minOuterLeft = $minLabelHandler.offset().left,
                    minWidth = $minLabelHandler.outerWidth(),
                    minOuterRight = minOuterLeft + minWidth,
                    maxOuterLeft = $maxLabelHandler.offset().left,
                    rangeLabelsPosition = maxOuterLeft - minOuterRight - 2,
                    marginValue = (2 - rangeLabelsPosition) / 2;

                $minLabelHandler.css('left', '-=' + marginValue);
                $maxLabelHandler.css('left', '+=' + marginValue);

                if (Math.floor(rangeLabelsPosition) > 2) {
                    $minLabelHandler.css('left', '0');
                    $maxLabelHandler.css('left', '0');
                }
            },
            getBinRange: function (rangePerBin, index, sliderMin) {
                var min = rangePerBin * index + sliderMin,
                    max = rangePerBin * (index + 1) - 1;

                if (rangePerBin === 1) max = min;

                return [min, max];
            },

            setOpacity: function (bin, val) {
                $(bin).css('opacity', val);
            },

            convertToHeight: function (v) {
                return parseInt(5 * v + 1);
            },

            calculateHeightRatio: function (bins, chartHeight) {
                var maxValue = Math.max.apply(null, bins);
                var height = facetDateChart.chart.convertToHeight(maxValue);
                if (height > chartHeight) {
                    return chartHeight / height;
                }
                return 1;
            },
        },
    };

    UX.facetDateChart = facetDateChart; // add to global namespace
})();
